import gql from "graphql-tag";
import getQuery from "./get_query";
import ParcisionCookies from "../../../utils/Cookies";

export default async function research_hash(cid: number) {
  const address = ParcisionCookies.get("address");
  const variables = {
    cid,
    address,
  };

  const query = gql`
    query MyQuery($cid: Float!, $address: String!) {
      researchHash(cid: $cid, address: $address) {
        research_sign
      }
    }
  `;

  const data = await getQuery(query, variables);
  // @ts-expect-error
  return data.researchHash;
}
